var $18e231809643ee60$exports = {};
$18e231809643ee60$exports = {
    "collectionLabel": `\u{645}\u{642}\u{62A}\u{631}\u{62D}\u{627}\u{62A}`
};


export {$18e231809643ee60$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
